(function () {
  if ($(".c-live-show-registration").length) {
    $(".c-live-show-registration").each(function (index, el) {
      var $this = $(this);

      $this.libriform({
        data: $this.serialize() + "&g=RZsSa3", // important to add "g" in data
        url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe?a=UpXmWE&g=RZsSa3", // AND in url too
        callBackSuccess: function ($form, data) {
          $form.trigger("reset");
          $(location).prop(
            "href",
            "https://celinevictor.com/pages/previous-live-shows"
          );
        },
        callBackError: function ($form, data) {
          $form.trigger("reset");
          $(".c-manipulate-class__form-error--5").click();
        },
      });
    });
  }
})();

(function () {
  if (
    window.location.pathname != "/pages/liveshow" &&
    window.location.pathname != "/pages/live-consulting"
  ) {
    $.ajax({
      type: "GET",
      url: "https://liveshopping-api.bambuser.com/v1/shows?state=live",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "Token BgvMU91yoRFEfAPD2a7jYbUuyu2y1z5SKPNr6bHBiLM"
        );
      },
      success: function (data) {
        if (data.results.length) {
          $("body").append(
            '<div class="b-liveshow-preview" style="background-image: url( ' +
              data.results[0].curtains.pending.backgroundImage +
              ' );">' +
              '<button class="b-liveshow-preview__close"></button>' +
              '<div class="b-liveshow-preview__content">' +
              '<a href="/pages/liveshow#shows" class="b-liveshow-preview__title">Live Show Läuft Gerade</a>' +
              '<a href="/pages/liveshow#shows" class="-ol-btn -ol-btn_sm _w_full" tabindex="0"><span class="-ol-btn__text">Teilnehmen</span></a>' +
              "</div>" +
              "</div>"
          );

          $("body").on("click", ".b-liveshow-preview__close", function () {
            $(".b-liveshow-preview").remove();
          });
        }
      },
    });
  }
})();

(function () {
  if ($(".c-bambuser-list-live").length) {
    buildBambuserList(
      "https://liveshopping-api.bambuser.com/v1/shows?state=live",
      "Jetzt Live",
      "c-bambuser-list-live"
    );
  }
})();

(function () {
  if ($(".c-bambuser-list-next").length) {
    buildBambuserList(
      "https://liveshopping-api.bambuser.com/v1/shows",
      "Nächste Live Shows",
      "c-bambuser-list-next",
      "next"
    );
  }
})();

(function () {
  if ($(".c-bambuser-list-prev").length) {
    buildBambuserList(
      "https://liveshopping-api.bambuser.com/v1/shows?state=ended",
      "Vergangene Live Shows",
      "c-bambuser-list-prev"
    );
  }
})();

function buildBambuserList(url, title, className, type) {
  $.ajax({
    type: "GET",
    url: url,
    beforeSend: function (xhr) {
      xhr.setRequestHeader(
        "Authorization",
        "Token BgvMU91yoRFEfAPD2a7jYbUuyu2y1z5SKPNr6bHBiLM"
      );
    },
    success: function (data) {
      var htmlList = "",
        result = "",
        reverse = false,
        reverseClass = "";

      // to make play button clickable
      if (!window.initBambuserLiveShopping) {
        window.initBambuserLiveShopping = function (item) {
          window.initBambuserLiveShopping.queue.push(item);
        };
        window.initBambuserLiveShopping.queue = [];

        var scriptNode = document.createElement("script");
        scriptNode["src"] =
          "https://lcx-embed.bambuser.com/celine-victor/embed.js";

        document.body.appendChild(scriptNode);
      }

      if (type == "next") {
        reverseClass = " _flex_dir_row_reverse _just_cont_end";
      }

      data.results.forEach(function (item, i, arr) {
        var nextPopup = "",
          nextPopupModal = "",
          btnPlayId = "",
          linkPlayId = "";

        if (type != "next") {
          btnPlayId = ' id="' + className + "__btn-play-" + i + '"';
          linkPlayId = ' id="' + className + "__link-play-" + i + '"';
        }

        if (
          type == "next" &&
          (item.state == "ended" || item.state == "upcoming")
        ) {
          return true;
        }

        var dateOptions = {
            weekday: "long",
            year: undefined,
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          },
          date = new Date(item.scheduledStartAt).toLocaleString(
            "de-DE",
            dateOptions
          );

        if (type == "next") {
          $("body").prepend(
            '<p class="c-video__description">' + item.description + "</p>"
          );

          var formID = $(".c-video__description").find(".c-video__id").text();

          $(".c-video__description").remove();

          nextPopup =
            ' c-manipulate-class" data-c-manipulate-class-element="body, .c-manipulate-class----modal--0' +
            (i * 1 + 2) +
            '" data-c-manipulate-class-class="_modal_active, b-modal_active';
          nextPopupModal =
            '<div class="b-modal c-manipulate-class----modal--0' +
            (i * 1 + 2) +
            '">' +
            '<div class="b-modal__inner">' +
            '<div class="b-modal__overlay c-manipulate-class" data-c-manipulate-class-element="body, .c-manipulate-class----modal--0' +
            (i * 1 + 2) +
            '" data-c-manipulate-class-class="_modal_active, b-modal_active" data-c-manipulate-class-operation-type="remove, remove"></div>' +
            '<div class="b-box b-box_without_outside_space b-box_with_image _block_center b-modal__box">' +
            '<div class="b-box__img-aside" style="background-image: url( ' +
            item.curtains.pending.backgroundImage +
            ' );"></div>' +
            '<div class="b-box__close b-modal__close c-form__btn-done c-manipulate-class" data-c-manipulate-class-element="body, .c-manipulate-class----modal--0' +
            (i * 1 + 2) +
            '" data-c-manipulate-class-class="_modal_active, b-modal_active" data-c-manipulate-class-operation-type="remove, remove"></div>' +
            '<div class="b-box__body">' +
            '<div class="b-heading-4 b-heading-4_without_decoration _m_b_20 _m_b_15_tb _m_horiz_5_neg_tb_xs">' +
            '<div class="_flex _m_b_30 _m_b_20_tb">' +
            '<div class="b-heading-4__title b-heading-4__title_lg">' +
            '<h4 class="b-heading-4__title-text">' +
            item.title +
            "</h4>" +
            "</div>" +
            "</div>" +
            '<p class="b-text-lg b-text-lg_last _c_black">Registriere dich hier für die kostenlose Live Show am</p>' +
            "</div>" +
            '<div class="_m_b_25 _m_b_20_tb">' +
            '<p class="b-note">' +
            date +
            "</p>" +
            "</div>" +
            '<form class="c-video__form">' +
            '<div class="-ol-row-input -ol-row-input_xl _m_b_20_tb">' +
            '<label class="-ol-label _p_l_0 _text_center" for="k_id_name">' +
            '<span class="-ol-label-text">Name</span>' +
            "</label>" +
            '<div class="-ol-input-wrap">' +
            '<input class="-ol-input _text_center c-form__required" placeholder="Name" name="first_name" id="k_id_name" autocorrect="off" autocapitalize="off">' +
            "</div>" +
            "</div>" +
            '<div class="-ol-row-input -ol-row-input_xl _m_b_20_tb">' +
            '<label class="-ol-label _p_l_0 _text_center" for="k_id_email">' +
            '<span class="-ol-label-text">E-mail</span>' +
            "</label>" +
            '<div class="-ol-input-wrap">' +
            '<input class="-ol-input _text_center c-form__required" type="email" data-c-form-type="email" placeholder="E-mail" name="email" id="k_id_email" autocorrect="off" autocapitalize="off">' +
            "</div>" +
            "</div>" +
            '<input type="hidden" name="listID" class="c-video__id-input" value="' +
            formID +
            '">' +
            '<button type="submit" class="-ol-btn -ol-btn_w_fix_lg _w_full">' +
            '<span class="-ol-btn__text">Jetzt registrieren</span>' +
            "</button>" +
            "</form>" +
            "</div>" +
            "</div>" +
            "</div>" +
            "</div>";
        }

        htmlList +=
          '<div class="b-list-blocks__item -ol-col-4 -ol-col-tb-6 -ol-col-mb-12 c-video">' +
          '<div class="b-video">' +
          '<div class="b-video__item">' +
          "<div" +
          btnPlayId +
          ' class="b-video__media' +
          nextPopup +
          '">' +
          '<div class="b-video__media-btn"></div>' +
          '<div class="b-video__media-video" style="background-image: url( ' +
          item.curtains.pending.backgroundImage +
          ' );"></div>' +
          "</div>" +
          '<h4 class="b-video__heading">' +
          item.title +
          "</h4>" +
          '<p class="b-video__subheading">' +
          date +
          "</p>" +
          '<div class="b-text">' +
          item.description +
          "</div>" +
          "</div>" +
          '<div class="b-video__item _flex">' +
          "<div" +
          linkPlayId +
          ' class="b-link-next _cur_p' +
          nextPopup +
          '">' +
          '<div class="b-link-next__text">Erfahren Sie mehr</div>' +
          "</div>" +
          "</div>" +
          "</div>" +
          nextPopupModal +
          "</div>";
      });

      if (htmlList.length) {
        result =
          "" +
          '<div class="b-heading-4 _m_b_45 _m_b_30_tb_xs">' +
          '<div class="b-heading-4__title b-heading-4__title_lg">' +
          '<h3 class="b-heading-4__title-text">' +
          title +
          "</h3>" +
          "</div>" +
          "</div>" +
          '<div class="b-list-blocks b-list-blocks_p b-list-blocks_30 _m_b_70 _m_b_60_tb _m_b_40_mb">' +
          '<div class="b-list-blocks__inner _f_wrap' +
          reverseClass +
          '">' +
          htmlList +
          "</div>" +
          "</div>";
      }

      $("." + className).html(result);

      data.results.forEach(function (item, i, arr) {
        window.initBambuserLiveShopping({
          showId: item.id,
          node: document.getElementById(className + "__btn-play-" + i),
          type: "overlay",
        });

        window.initBambuserLiveShopping({
          showId: item.id,
          node: document.getElementById(className + "__link-play-" + i),
          type: "overlay",
        });
      });

      $(".c-video__form").each(function (index, element) {
        var $this = $(this),
          typeID = $this.find(".c-video__id-input").val();

        // Connect liveshow registration form with custom Klaviyo list
        if (typeID) {
          $this.libriform({
            data: $this.serialize() + "&g=" + typeID, // important to add "g" in data
            url:
              "https://manage.kmail-lists.com/ajax/subscriptions/subscribe?a=UpXmWE&g=" +
              typeID, // AND in url too
          });
        }

        // Connect liveshow registration form with general Klaviyo list
        $this.libriform({
          data: $this.serialize() + "&g=TLDXwQ", // important to add "g" in data
          url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe?a=UpXmWE&g=TLDXwQ", // AND in url too
          callBackSuccess: function ($form, data) {
            $form.trigger("reset");
            $(".c-form__btn-done").click();
            $(".c-manipulate-class__form-success--4").click();
          },
          callBackError: function ($form, data) {
            $form.trigger("reset");
            $(".c-form__btn-done").click();
            $(".c-manipulate-class__form-error--5").click();
          },
        });
      });
    },
    error: function (data) {},
  });
}
